import { render, staticRenderFns } from "./EducationalRatingDelete.vue?vue&type=template&id=bef6c8b0&"
import script from "./EducationalRatingDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports